"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LevelEnum = void 0;
var LevelEnum;
(function (LevelEnum) {
    LevelEnum["Basic"] = "basic";
    LevelEnum["Intermediate"] = "intermediate";
    LevelEnum["Advanced"] = "advanced";
})(LevelEnum = exports.LevelEnum || (exports.LevelEnum = {}));
//# sourceMappingURL=level.enum.js.map